module.exports = __webpack_public_path__ + "images/orange_highlight.8e8b16b8296143389324b59333682538.png";